/**
 * PDP — carrossel de até 5 vídeos por produto.
 */
(function () {
  function bind(root) {
    var track = root.querySelector('[data-md-extra-videos-track]');
    var next = root.querySelector('[data-md-extra-videos-next]');
    if (!track || !next) return;

    next.addEventListener('click', function () {
      var cell = track.querySelector('[data-md-extra-videos-cell]');
      var step = cell ? cell.getBoundingClientRect().width + 8 : track.clientWidth / 2;
      var max = track.scrollWidth - track.clientWidth;
      var target = track.scrollLeft + step;
      if (target >= max - 4) target = 0;
      track.scrollTo({ left: target, behavior: 'smooth' });
    });
  }

  function init() {
    document.querySelectorAll('[data-md-extra-videos]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
